import { useMutation } from '@tanstack/react-query';
import { ChatBackend, UpdateOrganizationChatBackendDto } from 'models/organization/dto/organization.dto';
import { useApiClient } from '../../../apiClient';
import { useSelectedOrganization } from './useSelectedOrganization';

// Phase 6 chat cutover flag. Hits POST :id/chat-backend on the API — elevated
// (platform) admins only; the endpoint 403s for regular operators. The endpoint
// returns only the flipped flag ({ chatBackend }), so we patch it into the
// cached selectedOrganization locally. Mirrors
// useUpdateOrganizationPayForOthersEnabled in shape and intent.
export const useUpdateOrganizationChatBackend = (
    organizationId: string,
    onSuccess: () => void,
) => {
    const apiClient = useApiClient();
    const { selectedOrganization, setSelectedOrganization } = useSelectedOrganization();

    return useMutation({
        mutationKey: ['updateOrganizationChatBackend', organizationId],
        mutationFn: (body: UpdateOrganizationChatBackendDto) =>
            apiClient.fetchApi<{ chatBackend: ChatBackend }, UpdateOrganizationChatBackendDto>({
                method: 'POST',
                endpoint: `organizations/${organizationId}/chat-backend`,
                body,
            }),
        onSuccess: (data) => {
            onSuccess();
            // Only update the selected-org cache when the response is for the
            // org currently in view — defensive against the operator switching
            // orgs while the mutation is in flight.
            if (selectedOrganization && organizationId === selectedOrganization.id) {
                setSelectedOrganization({
                    ...selectedOrganization,
                    chatBackend: data.chatBackend,
                });
            }
        },
    });
};
